import React, { useEffect, useState } from 'react';
import '../css/Business.css';

const Business: React.FC = () => {
    const [visibleDivs, setVisibleDivs] = useState<number>(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setVisibleDivs((prev: any) => {
                if (prev < 4) {
                    return prev + 1;
                } else {
                    clearInterval(interval);
                    return prev;
                }
            });
        }, 800);
        return () => clearInterval(interval);
    }, []);
    return (
        <div className="business">
            <div className="business-content">
                <div className="business-title">
                    <div style={{ fontSize: '1.7rem', fontWeight: 'bold' }}>Business Introduction</div>
                    <div style={{ fontSize: '1.4rem' }}>사업 소개</div>
                </div>

                <div className="business-description">
                    <div
                        className={`business-desc-block ${visibleDivs >= 1 ? 'visible' : ''}`}
                        style={{
                            backgroundImage: `url(${process.env.PUBLIC_URL + '/business1.jpg'})`,
                            backgroundColor: `rgba(0, 0, 0, 0.5)`,
                            backgroundBlendMode: 'multiply',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundOrigin: 'border-box',
                            backgroundPosition: 'center',
                            overflow: 'hidden',
                        }}
                    >
                        <div className="business-block-title">
                            <br />
                            <br />
                            <div style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>
                                Foreign Exchange
                                <br />
                                Trading Operations
                            </div>
                            외환 트레이딩 운영
                            <br />
                            <br />
                            ──────
                            <br />
                        </div>
                        <div className="business-block-element">HIONS 교육지원팀</div>
                        <div className="business-block-element">TEAM FX1 트레이딩팀</div>
                        <div className="business-block-element">AI Bot 투자 개발팀</div>
                    </div>
                    <div
                        className={`business-desc-block ${visibleDivs >= 2 ? 'visible' : ''}`}
                        style={{
                            backgroundImage: `url(${process.env.PUBLIC_URL + '/business2.jpg'})`,
                            backgroundColor: `rgba(0, 0, 0, 0.5)`,
                            backgroundBlendMode: 'multiply',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundOrigin: 'border-box',
                            backgroundPosition: 'center',
                            overflow: 'hidden',
                        }}
                    >
                        <div className="business-block-title">
                            <br />
                            <br />
                            <div style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>
                                Securities and Futures <br />
                                IB Business
                            </div>
                            증권 선물 IB 사업 운영
                            <br />
                            <br />
                            ──────
                            <br />
                        </div>
                        <div className="business-block-element">거래 수수료 수익</div>
                        <div className="business-block-element">카피트레이딩 수익</div>
                        <div className="business-block-element">유저 커미션 수수료</div>
                    </div>
                    <div
                        className={`business-desc-block ${visibleDivs >= 3 ? 'visible' : ''}`}
                        style={{
                            backgroundImage: `url(${process.env.PUBLIC_URL + '/business3.jpg'})`,
                            backgroundColor: `rgba(0, 0, 0, 0.5)`,
                            backgroundBlendMode: 'multiply',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundOrigin: 'border-box',
                            backgroundPosition: 'center',
                            overflow: 'hidden',
                        }}
                    >
                        <div className="business-block-title">
                            <br />
                            <br />
                            <div style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>
                                Trading Education <br />
                                Business
                            </div>
                            트레이딩 교육 사업 운영
                            <br />
                            <br />
                            ──────
                            <br />
                        </div>
                        <div className="business-block-element">기초과정</div>
                        <div className="business-block-element">실전과정</div>
                        <div className="business-block-element">전문화과정</div>
                    </div>
                    <div
                        className={`business-desc-block ${visibleDivs >= 4 ? 'visible' : ''}`}
                        style={{
                            backgroundImage: `url(${process.env.PUBLIC_URL + '/business4.jpg'})`,
                            backgroundColor: `rgba(0, 0, 0, 0.5)`,
                            backgroundBlendMode: 'multiply',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundOrigin: 'border-box',
                            backgroundPosition: 'center',
                            overflow: 'hidden',
                        }}
                    >
                        <div className="business-block-title">
                            <br />
                            <br />
                            <div style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>
                                AI Program <br />
                                Development Project
                            </div>
                            AI 프로그램 개발 사업
                            <br />
                            <br />
                            ──────
                            <br />
                        </div>
                        <div className="business-block-element">AI 개발 및 분양</div>
                        <div className="business-block-element">AI 커미션 수수료</div>
                        <div className="business-block-element">코인 거래소 전용 AI 개발 및 런칭</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Business;

/*
            <div className="business-cover">
                <div className="business-content">
                    <div className="business-title">사업 소개</div>

                    <div className="business-description">
                        <div className="business-desc-block">
                            <div className="business-block-title">
                                <img src={process.env.PUBLIC_URL + '/business1.jpg'} width="300px" height="200px"></img>
                                <br></br>
                                <br></br>──────<br></br>
                                <br></br>외환 트레이딩 운영
                            </div>
                            <div className="business-block-element">HIONS 교육지원팀</div>
                            <div className="business-block-element">TEAM FX1 트레이딩팀</div>
                            <div className="business-block-element">AI Bot 투자 개발팀</div>
                        </div>
                        <div className="business-desc-block">
                            <div className="business-block-title">
                                <img src={process.env.PUBLIC_URL + '/business2.jpg'} width="300px" height="200px"></img>
                                <br></br>
                                <br></br>──────<br></br>
                                <br></br>증권 선물 IB 사업
                            </div>
                            <div className="business-block-element">거래 수수료 수익</div>
                            <div className="business-block-element">AI 트레이딩 수익</div>
                            <div className="business-block-element">유저 커미션 수수료</div>
                        </div>
                        <div className="business-desc-block">
                            <div className="business-block-title">
                                <img src={process.env.PUBLIC_URL + '/business3.jpg'} width="300px" height="200px"></img>
                                <br></br>
                                <br></br>──────<br></br>
                                <br></br>트레이딩 교육 사업
                            </div>
                            <div className="business-block-element">기초과정</div>
                            <div className="business-block-element">실전과정</div>
                            <div className="business-block-element">전문화과정</div>
                        </div>
                    </div>
                </div>
            </div>
            */
